import { render, staticRenderFns } from "./MarksRecordPrint.vue?vue&type=template&id=1fb0f4f3&scoped=true&"
import script from "./MarksRecordPrint.vue?vue&type=script&lang=js&"
export * from "./MarksRecordPrint.vue?vue&type=script&lang=js&"
import style0 from "./MarksRecordPrint.vue?vue&type=style&index=0&id=1fb0f4f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb0f4f3",
  null
  
)

export default component.exports